import {
  copyrightRange,
  ExternalLink,
  IndieTabletopClubLogo,
  ReleaseInfo,
  type LinkUtmParams,
} from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { hrefs } from "../App/hrefs.tsx";
import shinobi from "./shinobi.png";
import { footer } from "./style.css.ts";

export function Footer() {
  const utm: LinkUtmParams = { content: "footer" };

  const fathomAnalytics = (
    <ExternalLink className={interactiveText} href={hrefs.fathom()}>
      Fathom Analytics
    </ExternalLink>
  );

  const malev = <>Malev Da Shinobi</>;

  const itc = (
    <ExternalLink className={interactiveText} href={hrefs.itc(utm)}>
      Indie Tabletop Club
    </ExternalLink>
  );

  const terms = (
    <ExternalLink href={hrefs.terms(utm)} className={interactiveText}>
      Terms of Service
    </ExternalLink>
  );

  const privacy = (
    <ExternalLink href={hrefs.privacy(utm)} className={interactiveText}>
      Privacy Policy
    </ExternalLink>
  );

  const cookies = (
    <ExternalLink href={hrefs.cookies(utm)} className={interactiveText}>
      Cookie Policy
    </ExternalLink>
  );

  return (
    <footer className={footer.container}>
      <div className={footer.content}>
        <div className={footer.logos}>
          <div className={footer.logoLink}>
            <img
              src={shinobi}
              alt="Malev Da Shinobi"
              className={footer.shinobi}
            />
          </div>

          <ExternalLink href={hrefs.itc(utm)} className={footer.logoLink}>
            <IndieTabletopClubLogo />
          </ExternalLink>
        </div>

        <p>
          This app uses no tracking, other than anonymous, GDPR-compliant{" "}
          {fathomAnalytics}. For more information, see our {terms}, {privacy},
          and {cookies}.
        </p>

        <p>
          Greathelm {copyrightRange(2025)} {malev}. All rights reserved.
        </p>

        <p>
          Greathelm App {copyrightRange(2026)} {itc}. All rights reserved.
        </p>
        <p>
          <Link className={interactiveText} href="~/share">
            Share app
          </Link>
          {" · "}
          <ReleaseInfo
            branch={BRANCH}
            shortcode={COMMIT_SHORTCODE}
            backgroundColor="hsl(0 0% 100% / 0.2)"
          />
        </p>
      </div>
    </footer>
  );
}
